<template>
  <tr>
    <td class="clickable" :class="{'info': !isShortView}" @click="onPlayerSelected(playerKey)">
      {{player.name}}
      <span v-if="match.now && match.now.bowler == playerKey">&starf;</span>
    </td>
    <template v-if="!isShortView">
    <td>{{playerInnings.bowling.overs}}</td>
    <td>{{playerInnings.bowling.maiden_overs}}</td>
    <td>{{playerInnings.bowling.runs}}</td>
    <td>{{playerInnings.bowling.wickets}}</td>
    <td>{{playerInnings.bowling.economy}}</td>
    <td>{{playerInnings.bowling.extras_wide}}</td>
    <td>{{playerInnings.bowling.extras_noball}}</td>
    </template>
    <template v-else>
      <td class="info">
        {{playerInnings.bowling.wickets}}/{{playerInnings.bowling.overs}}
      </td>
      <td>
        <span>{{playerInnings.bowling.economy}}</span>
        <span class="silent"> Econ</span>
      </td>
    </template>
  </tr>
</template>
<script>
export default {
  data () {
    return {
      innings: this.match.innings[`${this.teamI}_${this.inningsNumber}`]
    }
  },
  props: {
    match: Object,
    playerKey: String,
    inningsNumber: String,
    isShortView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    player () {
      return this.match.players[this.playerKey]
    },

    playerInnings () {
      return this.match.players[this.playerKey].match.innings[this.inningsNumber]
    }
  },
  methods: {
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    }
  }
}
</script>
